import { AbstractComponent } from "appworks/components/abstract-component";
import { ComponentFactory } from "appworks/components/factories/component-factory";
import { BigWinComponent, BigWinTierConfig, CountMode } from "slotworks/components/bigwin/big-win-component";

export class DMFBigWinFactory implements ComponentFactory {

    constructor(
        protected countMode: CountMode = CountMode.TIERED,
        protected upgrade: boolean = true,
        protected tiers?: BigWinTierConfig[]
    ) {
        if (!tiers) {
            this.tiers = [
                {
                    threshold: 16,
                    countTime: 4000,
                    waitTime: 4000,
                    scene: "celebration_1"
                },
                {
                    threshold: 25,
                    countTime: 4000,
                    waitTime: 4000,
                    scene: "celebration_2"
                },
                {
                    threshold: 50,
                    countTime: 4000,
                    waitTime: 4000,
                    scene: "celebration_3"
                },
                {
                    threshold: 75,
                    countTime: 4000,
                    waitTime: 4000,
                    scene: "celebration_4"
                },
                {
                    threshold: 100,
                    countTime: 4000,
                    waitTime: 4000,
                    scene: "celebration_5"
                }
            ];
        }
    }

    public build(): AbstractComponent {
        const bigWin = new BigWinComponent();
        bigWin.countupMode = this.countMode;
        bigWin.upgrade = this.upgrade;

        if (this.tiers) {
            for (const tier of this.tiers) {
                bigWin.addWinTier(tier);
            }
        }

        return bigWin;
    }
}
